import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  const dsn = import.meta.env.PUBLIC_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.PUBLIC_SENTRY_ENV || "production",
    release: import.meta.env.PUBLIC_SENTRY_RELEASE,
    tracesSampleRate: 0,
  });
  initialized = true;
}

export function reportFormError(
  error: unknown,
  context: {
    endpoint: string;
    status?: number;
    serverError?: string;
    leadMagnetSlug?: string;
    eventSlug?: string;
  },
) {
  if (!initialized) return;
  const err = error instanceof Error ? error : new Error(String(error));
  Sentry.captureException(err, {
    tags: {
      error_class: "form_submission",
      form_endpoint: context.endpoint,
      ...(context.status !== undefined ? { http_status: String(context.status) } : {}),
      ...(context.leadMagnetSlug ? { lead_magnet_slug: context.leadMagnetSlug } : {}),
      ...(context.eventSlug ? { event_slug: context.eventSlug } : {}),
    },
    contexts: {
      form: {
        endpoint: context.endpoint,
        status: context.status,
        serverError: context.serverError,
        href: typeof window !== "undefined" ? window.location.href : undefined,
      },
    },
  });
}

export function reportHydrationError(error: unknown, info: { componentStack?: string | null }) {
  if (!initialized) return;
  Sentry.captureException(error, {
    tags: { error_class: "hydration" },
    contexts: {
      react: {
        componentStack: info.componentStack,
        href: typeof window !== "undefined" ? window.location.href : undefined,
      },
    },
  });
}
